import { Rectangle } from "../../maths/Rectangle";
import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
const className = "DrawEllipseCmd";
export class DrawEllipseCmd {
    constructor() {
        this.lineWidth = 0;
    }
    static create(x, y, width, height, fillColor, lineColor, lineWidth, percent) {
        var cmd = Pool.getItemByClass(className, DrawEllipseCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.width = width;
        cmd.height = height;
        cmd.fillColor = fillColor;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        cmd.percent = percent;
        return cmd;
    }
    recover() {
        this.fillColor = null;
        this.lineColor = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        let offset = (this.lineWidth >= 1 && this.lineColor) ? this.lineWidth / 2 : 0;
        if (this.percent && runner.sprite) {
            let w = runner.sprite.width;
            let h = runner.sprite.height;
            runner._drawEllipse(this.x * w + gx, this.y * h + gy, this.width * w - offset, this.height * h - offset, this.fillColor, this.lineColor, this.lineWidth);
        }
        else {
            runner._drawEllipse(this.x + gx, this.y + gy, this.width - offset, this.height - offset, this.fillColor, this.lineColor, this.lineWidth);
        }
    }
    get cmdID() {
        return DrawEllipseCmd.ID;
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x - this.width, this.y - this.height, this.width * 2, this.height * 2);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
        }
        rect.getBoundPoints(assembler.points);
    }
}
DrawEllipseCmd.ID = className;
ClassUtils.regClass(className, DrawEllipseCmd);
